import { SET_ATTRIBUTES_FROM_IDC } from '../actions/types';

export default function attributesFromIDC(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_ATTRIBUTES_FROM_IDC:
				return action.payload;

			// no default
		}
	}

	return state;
}
